import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SmileOutlinedSvg from "@ant-design/icons-svg/es/asn/SmileOutlined";
import AntdIcon from '../components/AntdIcon';
var SmileOutlined = function SmileOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: SmileOutlinedSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(SmileOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'SmileOutlined';
}
export default RefIcon;